import { styled as g, Box as N } from "@mui/material";
import R from "../share/generic/AnimatedBox.js";
import { RESTRICT_MODE as e } from "../../constants/layout.js";
import { Role as u } from "../../constants/role.js";
import { useAccountContext as E } from "../../contexts/account/AccountContext.js";
import { getAccessToken as L } from "../../util/authenication/index.js";
import I from "../../../ui-lib/components/MuiLoading.js";
import { useRouter as P } from "next/router";
import * as n from "ramda";
import { useState as T, useCallback as G, useEffect as d } from "react";
import { useTranslation as y } from "react-i18next";
import { jsxs as A, Fragment as k, jsx as l } from "react/jsx-runtime";
const v = g(N)`
  align-items: center;
  background-color: #26282a;
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0px;
  position: fixed;
  top: 0px;
  width: 100vw;
  z-index: 1;
`, w = g(R)`
  align-items: center;
  background: linear-gradient(90deg, #333333 0%, #343434 35%, #445566 100%);
  display: flex;
  flex: 1;
  justify-content: center;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  white-space: pre-line;
`, q = (h) => {
  const {
    children: x,
    restriction: p
  } = h, {
    t: C
  } = y(), [t, s] = T(e.WAITING), o = P(), {
    account: r,
    isLoggedIn: m,
    setShowLoginPopup: f
  } = E(), i = G((c) => {
    const a = n.pipe(n.split(/[?#]/), n.propOr("", "0")), O = n.propOr(u.Guest, a(c), p);
    r.role < O ? s(m ? e.BLOCK_SCREEN : e.PROMPT_LOGIN) : s(e.NONE);
  }, [r.role, m, p]);
  return d(() => {
    const c = n.isNil(L()), a = r.role !== u.Guest;
    if (c || a)
      return i(o.asPath), o.events.on("routeChangeComplete", i), () => {
        o.events.off("routeChangeComplete", i);
      };
  }, [r, i, o.asPath, o.events]), d(() => {
    t === e.PROMPT_LOGIN && f(!0);
  }, [t, f]), /* @__PURE__ */ A(k, {
    children: [t === e.BLOCK_SCREEN && /* @__PURE__ */ l(w, {
      children: C("restricted.401")
    }), t === e.NONE && x, t === e.WAITING && /* @__PURE__ */ l(v, {
      children: /* @__PURE__ */ l(I, {
        loading: !0
      })
    })]
  });
};
export {
  q as default
};
//# sourceMappingURL=EnoughRoleOnly.js.map
